import { fetchQueueReducer } from "@payping/utils/fetchQueue";
import { CombinedState, Reducer, combineReducers } from "redux";
import auth, { AuthState } from "./auth";
import categories, { CategoryState } from "./categories";
import client, { ClientState } from "./client";
import coupons, { CouponState } from "./coupons";
import customers, { CustomerState } from "./customers";
import digitalAccount, { DigitalAccountState } from "./digitalAccount";
import fastInvoice, { FastInvoiceState } from "./fastInvoice";
import invoices, { InvoiceState } from "./invoices";
import organization, { OrganizationState } from "./organization";
import permalinks, { PermaLinkState } from "./permalinks";
import pos, { PosState } from "./pos";
import products, { ProductState } from "./products";
import reports, { ReportState } from "./reports";
import requestMoney, { RequestMoneyState } from "./requestMoney";
import service, { ServiceState } from "./service";
import settings, { SettingState } from "./settings";
import user, { UserState } from "./user";
import withdraws, { WithdrawState } from "./withdraws";
import cashOuts, { CashOutState } from "./cashout";

export interface SdkReducers {
  auth: typeof auth;
  categories: typeof categories;
  client: typeof client;
  coupons: typeof coupons;
  customers: typeof customers;
  digitalAccount: typeof digitalAccount;
  fastInvoice: typeof fastInvoice;
  fetchQueue: typeof fetchQueueReducer;
  invoices: typeof invoices;
  organization: typeof organization;
  permalinks: typeof permalinks;
  pos: typeof pos;
  products: typeof products;
  reports: typeof reports;
  service: typeof service;
  settings: typeof settings;
  user: typeof user;
  withdraws: typeof withdraws;
  requestMoney: typeof requestMoney;
  cashOuts: typeof cashOuts;
}

export interface SdkStoreStates {
  auth: AuthState;
  categories: CategoryState;
  client: ClientState;
  coupons: CouponState;
  customers: CustomerState;
  digitalAccount: DigitalAccountState;
  fastInvoice: FastInvoiceState;
  fetchQueue: ReturnType<typeof fetchQueueReducer>;
  invoices: InvoiceState;
  organization: OrganizationState;
  permalinks: PermaLinkState;
  pos: PosState;
  products: ProductState;
  reports: ReportState;
  service: ServiceState;
  settings: SettingState;
  user: UserState;
  withdraws: WithdrawState;
  requestMoney: RequestMoneyState;
  cashOuts: CashOutState;
}

export default function createRootReducer<S extends SdkStoreStates = SdkStoreStates>(
  appReducers: Record<string, Reducer> = {}
): Reducer<CombinedState<S>> {
  const reducers: SdkReducers = {
    auth,
    cashOuts,
    categories,
    client,
    coupons,
    customers,
    digitalAccount,
    fastInvoice,
    fetchQueue: fetchQueueReducer,
    invoices,
    organization,
    permalinks,
    pos,
    products,
    reports,
    requestMoney,
    service,
    settings,
    user,
    withdraws,
    ...appReducers,
  };

  return combineReducers(reducers) as Reducer<CombinedState<S>>;
}

export { CLEAR_LIST, LOGGED_OUT } from "./constants";
export { PrinterConfig, PrintPaperSizeTypes } from "./settings";
export { ClearListAction, LoggedOutAction, SdkThunkActionResult, SdkThunkDispatch } from "./types";
